import { IProject } from '@app/core/state/entities/project/project.entity';
import { selectCurrentProject } from '@app/core/state/entities/project/project.selectors';
import { createSelector } from '@ngrx/store';
import { selectEntityMap } from '@app/core/state/entities/entity.selectors';
import { IMemberTableItem } from '@app/project/project-admin/project-members/membership-table/membership-table.component';
import { IJoinRequest } from '@core/state/entities/join-request/join-request.entity';
import { FullName, RequestStatus } from '@core/services/api-client.generated';
import { entityKey } from '@core/state/entities/entity-name-map';
import { throwErrorExp } from '@core/actions/util';
import {selectCurrentProjectDetails} from '@core/state/entities/project-details/project-details.selectors';
import {selectCurrentProjectSecureDetails} from '@core/state/entities/project-secure-details/project-secure-details.selectors';

export interface IJoinRequestView extends IMemberTableItem, IJoinRequest {
  id: string;
  investigatorName: FullName;
  pictureUrl: string | null;
  message: string;
  automaticallyApproved: boolean;
  status: RequestStatus;
}

export const selectPendingJoinRequestsForCurrentProject = createSelector(
  selectCurrentProjectSecureDetails,
  selectEntityMap(entityKey.joinRequests),
  (projectSecureDetails, joinRequestsMap): IJoinRequest[] | null =>
    projectSecureDetails?.pendingJoinRequests.map(
      (id) => joinRequestsMap[id] ?? throwErrorExp('Join request not found')
    ) ?? null
);
export const toJoinRequestView = (
  joinRequest: IJoinRequest,
  projectGroupMap,
  joinRequestsMap,
  investigatorMap
):IJoinRequestView => ({
  ...joinRequest,
  tableId: joinRequest.requestedById,
  investigatorName: investigatorMap[joinRequest.requestedById].fullName,
  pictureUrl: investigatorMap[joinRequest.requestedById].pictureUrl,
  groups: undefined,
});

export const selectPendingJoinRequestViewsForCurrentProject = createSelector(
  selectPendingJoinRequestsForCurrentProject,
  selectEntityMap('projectGroups'),
  selectEntityMap('joinRequests'),
  selectEntityMap('investigators'),
  (
    joinRequests: IJoinRequest[] | null,
    projectGroupMap,
    joinRequestsMap,
    investigatorMap
  ): IJoinRequestView[] | null =>
    joinRequests?.map((jr) =>
      toJoinRequestView(jr, projectGroupMap, joinRequestsMap, investigatorMap)
    ) ?.sort(
      (a, b) =>
        a.investigatorName.surname.localeCompare(
          b.investigatorName.surname
        ) ||
        a.investigatorName.first.localeCompare(b.investigatorName.first) ||
        Date.parse(a.dateTimeCreated) - Date.parse(b.dateTimeCreated)
    ) ?? null
);
